import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
    name: "config",
    initialState: {
        propertyConfig: null,    // Config loaded from API endpoint (property-specific)
    },
    reducers: {
        setPropertyConfig: (state, action) => {
            state.propertyConfig = action.payload;
        },
        clearConfig: (state) => {
            state.propertyConfig = null;
        }
    },
});

export const { setPropertyConfig, clearConfig } = configSlice.actions;
export default configSlice.reducer;
